<template>
  <div>
    <div>
      <v-alert color="#0274b3" dark icon="mdi-checkbox-marked-circle" prominent>
        <h1>Congratulations you have viewed all candidates!</h1>
      </v-alert>

      <v-alert color="#0274b3" dark>
        Here's how you scored them. Now rank them by dragging the candidates to
        your preferred order.
      </v-alert>

      <v-data-table
        :headers="tableHeaders"
        :items="applicants"
        :loading="loading"
        item-key="id"
        :disable-pagination="true"
        :hide-default-footer="true"
        class="page__table"
      >
        <template v-slot:body="props">
          <draggable v-item="props.items" tag="tbody">
            <tr v-for="(item, index) in props.items" :key="item.id">
              <td>
                <v-icon small class="page__grab-icon">mdi-arrow-all</v-icon>
              </td>
              <td>{{ setIndex(item, index + 1) }}</td>

              <td>
                <ApplicantModal :applicant="item" />
              </td>
              <td>
                <v-rating
                  v-model="item.rating"
                  background-color="yellow darken-3"
                  color="orange"
                  half-increments
                  readonly
                  small
                ></v-rating>
              </td>
              <td>
                <v-checkbox v-model="item.isContact"></v-checkbox>
              </td>
              <td>
                <a :href="item.resume.url" download target="_blank">
                  <v-icon class="mr-2">mdi-download-circle</v-icon>
                </a>
              </td>
            </tr>
          </draggable>
        </template>
      </v-data-table>
      <v-btn @click="handleDownloadAll()" small>Download All</v-btn>

      <br />
      <br />
      <v-btn @click="handleComplete" color="primary">Complete Review</v-btn>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import ApplicantModal from '@/components/CandidateReview/ApplicantModal';
import COMPLETE_APPLICANT from '@/graphql/CompleteApplicant.gql';
import UPDATE_JOBPOST from '@/graphql/UpdateJobPost.gql';
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import saveAs from 'file-saver';
import { mapGetters } from 'vuex';

export default {
  components: {
    draggable,
    ApplicantModal,
  },
  data() {
    return {
      currentDisplay: 'rank',
      tableHeaders: [
        { text: '', sortable: false },
        { text: '#', sortable: false },
        { text: 'Name', sortable: false },
        { text: 'Rating', sortable: false },
        { text: 'Contact', sortable: false },
        { text: 'Resume', sortable: false },
      ],
    };
  },
  created() {
    if (this.getUserType !== 'recruiter') {
      this.$router.push('/');
    }
  },
  props: ['applicants', 'jobPost'],
  computed: {
    ...mapGetters(['getUserType']),
  },

  methods: {
    handleCurrentDisplay(display) {
      this.currentDisplay = display;
    },
    setIndex(item, index) {
      item.rank = index;
      return index;
    },
    handleDownloadAll() {
      var urls = [];

      for (var i = 0; i < this.applicants.length; i++) {
        console.log(this.applicants[i].resume.url);
        urls.push(this.applicants[i].resume.url);
      }

      console.log(urls);

      var zip = new JSZip();
      var count = 0;
      var zipFilename = 'zipFilename.zip';

      urls.forEach(function (url) {
        var filename = 'filename';
        // loading a file and add it in a zip file
        JSZipUtils.getBinaryContent(url, function (err, data) {
          if (err) {
            throw err; // or handle the error
          }
          zip.file(filename, data, { binary: true });
          count++;
          if (count == urls.length) {
            var zipFile = zip.generate({ type: 'blob' });
            saveAs(zipFile, zipFilename);
          }
        });
      });
    },
    handleComplete() {
      this.applicants.forEach((item) => {
        this.$apollo
          .mutate({
            // Query
            mutation: COMPLETE_APPLICANT,
            // Parameters
            variables: {
              id: item.id,
              rank: item.rank,
              selectedForContact: item.isContact ? item.isContact : false,
            },
          })
          .then((data) => {
            // Result
            console.log(data);
            //this.$router.go(this.$router.currentRoute);
          })
          .catch((error) => {
            // Error
            console.error(error);
            // We restore the initial user input
            // this.newTag = newTag;
          });
      });

      this.$apollo
        .mutate({
          // Query
          mutation: UPDATE_JOBPOST,
          // Parameters
          variables: {
            id: this.jobPost.id,
            status: 'complete',
          },
        })
        .then((data) => {
          console.log(data);
          this.$router.go(this.$router.currentRoute);
        })
        .catch((error) => {
          // Error
          console.error(error);
        });
    },
  },
};
</script>

<style>
.page__table {
  cursor: move;
}
</style>
